var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('DocsHome'),_c('CustomIntegration'),_c('OnSitePayments'),_c('RecurringBillingIntro'),_c('SplitPayments'),_c('PCI'),_c('TestingToolsIntro'),_c('Widgets'),_c('Ports_Ip'),_c('Faqs'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }